import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { isEmpty } from '../../helpers';
import { StyledFieldLabel, StyledTextField } from './styled';

type PropsType = {
  disabled: boolean;
  value: string;
  onChange: (value: string) => void;
  onValidationChange: (isValid: boolean) => void;
};

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EmailField = ({
  disabled,
  value,
  onChange,
  onValidationChange,
}: PropsType) => {
  const [error, setError] = useState<Error | null>(null);

  const validateEmail = (email: string) => {
    const trimmedEmail = email.trim();
    if (isEmpty(trimmedEmail) || EMAIL_REGEX.test(trimmedEmail)) {
      setError(null);
    } else {
      setError(Error('Please enter a valid email address'));
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    onChange(newValue);

    if (error) {
      validateEmail(newValue);
    }
  };

  const handleBlur = () => {
    validateEmail(value);
  };

  useEffect(() => {
    onValidationChange(!error && !isEmpty(value));
  }, [error, value, onValidationChange]);

  return (
    <Box>
      <StyledFieldLabel>Email address</StyledFieldLabel>
      <StyledTextField
        placeholder="Email"
        value={value}
        variant="outlined"
        disabled={disabled}
        error={!!error}
        helperText={error && error.message}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </Box>
  );
};

export default EmailField;
